import React from 'react';
import {Select} from "antd";

const EncodingParameters = () => {
    return (
        <div className="main-padding">
            <div className="camera-config-header">
                <span>Home</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>System Management</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>Video Coding</span>
            </div>
            <div className="row">
                <div className="col-md-6 p-2">
                    <div className="camera-config-content">
                        <div className="row">
                                <h5 className="text-white   mb-4">
                                    Main Stream
                                </h5>


                                <div className="row mt-3 align-items-center">
                                    <div className="col-md-4 text-end">
                                        <label  className="text-white">
                                            Stream Type
                                        </label>
                                    </div>
                                    <div className="col-md-8">
                                        <Select

                                            placeholder="Поиск, чтобы выбрать"
                                            optionFilterProp="children"
                                            className="w-100"

                                        >
                                            <option value="1">asd</option>
                                            <option value="3">asd</option>
                                            <option value="2">asd</option>
                                        </Select>
                                    </div>
                                </div>
                                <div className="row mt-3 align-items-center">
                                    <div className="col-md-4 text-end">
                                        <label  className="text-white">
                                            Video Coding
                                        </label>
                                    </div>
                                    <div className="col-md-8">
                                        <Select

                                            placeholder="Поиск, чтобы выбрать"
                                            optionFilterProp="children"
                                            className="w-100"

                                        >
                                            <option value="1">asd</option>
                                            <option value="3">asd</option>
                                            <option value="2">asd</option>
                                        </Select>
                                    </div>
                                </div>
                                <div className="row mt-3 align-items-center">
                                    <div className="col-md-4 text-end">
                                        <label  className="text-white">
                                            Resolution
                                        </label>
                                    </div>
                                    <div className="col-md-8">
                                        <Select

                                            placeholder="Поиск, чтобы выбрать"
                                            optionFilterProp="children"
                                            className="w-100"

                                        >
                                            <option value="1">asd</option>
                                            <option value="3">asd</option>
                                            <option value="2">asd</option>
                                        </Select>
                                    </div>
                                </div>
                                <div className="row mt-3 align-items-center">
                                    <div className="col-md-4 text-end">
                                        <label  className="text-white">
                                            Bitrate Type
                                        </label>
                                    </div>
                                    <div className="col-md-8">
                                        <Select

                                            placeholder="Поиск, чтобы выбрать"
                                            optionFilterProp="children"
                                            className="w-100"

                                        >
                                            <option value="1">asd</option>
                                            <option value="3">asd</option>
                                            <option value="2">asd</option>
                                        </Select>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-4 text-end text-white">Video Bit Rate</div>
                                    <div className="col-md-8">
                                        <div className="number-counter">
                                            <span className="minus">-</span>
                                            <input type="text" value="1"/>
                                            <span className="plus">+</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-4 text-end text-white">Video Frame Rate</div>
                                    <div className="col-md-8">
                                        <div className="number-counter">
                                            <span className="minus">-</span>
                                            <input type="text" value="1"/>
                                            <span className="plus">+</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-4 text-end text-white">THE I Frame Interval</div>
                                    <div className="col-md-8">
                                        <div className="number-counter">
                                            <span className="minus">-</span>
                                            <input type="text" value="1"/>
                                            <span className="plus">+</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="offset-4 col-md-4 mt-3">
                                    <button className="btn btn-primary">SET</button>
                                </div>
                            </div>
                    </div>
                </div>

                <div className="col-md-6 p-2">
                    <div className="camera-config-content">
                        <div className="row">
                                <h5 className="text-white   mb-4">
                                    Auxiliary Stream
                                </h5>


                                <div className="row mt-3 align-items-center">
                                    <div className="col-md-4 text-end">
                                        <label  className="text-white">
                                            Stream Type
                                        </label>
                                    </div>
                                    <div className="col-md-8">
                                        <Select

                                            placeholder="Поиск, чтобы выбрать"
                                            optionFilterProp="children"
                                            className="w-100"

                                        >
                                            <option value="1">asd</option>
                                            <option value="3">asd</option>
                                            <option value="2">asd</option>
                                        </Select>
                                    </div>
                                </div>
                                <div className="row mt-3 align-items-center">
                                    <div className="col-md-4 text-end">
                                        <label  className="text-white">
                                            Video Coding
                                        </label>
                                    </div>
                                    <div className="col-md-8">
                                        <Select

                                            placeholder="Поиск, чтобы выбрать"
                                            optionFilterProp="children"
                                            className="w-100"

                                        >
                                            <option value="1">asd</option>
                                            <option value="3">asd</option>
                                            <option value="2">asd</option>
                                        </Select>
                                    </div>
                                </div>
                                <div className="row mt-3 align-items-center">
                                    <div className="col-md-4 text-end">
                                        <label  className="text-white">
                                            Resolution
                                        </label>
                                    </div>
                                    <div className="col-md-8">
                                        <Select

                                            placeholder="Поиск, чтобы выбрать"
                                            optionFilterProp="children"
                                            className="w-100"

                                        >
                                            <option value="1">asd</option>
                                            <option value="3">asd</option>
                                            <option value="2">asd</option>
                                        </Select>
                                    </div>
                                </div>
                                <div className="row mt-3 align-items-center">
                                    <div className="col-md-4 text-end">
                                        <label  className="text-white">
                                            Bitrate Type
                                        </label>
                                    </div>
                                    <div className="col-md-8">
                                        <Select

                                            placeholder="Поиск, чтобы выбрать"
                                            optionFilterProp="children"
                                            className="w-100"

                                        >
                                            <option value="1">asd</option>
                                            <option value="3">asd</option>
                                            <option value="2">asd</option>
                                        </Select>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-4 text-end text-white">Video Bit Rate</div>
                                    <div className="col-md-8">
                                        <div className="number-counter">
                                            <span className="minus">-</span>
                                            <input type="text" value="1"/>
                                            <span className="plus">+</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-4 text-end text-white">Video Frame Rate</div>
                                    <div className="col-md-8">
                                        <div className="number-counter">
                                            <span className="minus">-</span>
                                            <input type="text" value="1"/>
                                            <span className="plus">+</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-4 text-end text-white">THE I Frame Interval</div>
                                    <div className="col-md-8">
                                        <div className="number-counter">
                                            <span className="minus">-</span>
                                            <input type="text" value="1"/>
                                            <span className="plus">+</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="offset-4 col-md-4 mt-3">
                                    <button className="btn btn-primary">SET</button>
                                </div>
                            </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default EncodingParameters;